var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LandingHero'),_vm._v(" "),_c('BaseBreadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbList}}),_vm._v(" "),_c('PageMeta',{attrs:{"title":_vm.pageTitle,"description":_vm.pageDescription}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }